import { WardSignalService } from './services/signalsService';
import { WardApiAdapter } from './adapter';
import { AbsencesApiResponse } from '@/features/absences/types';
import { ShopService } from '@/features/shop/services/shopServices';

// Main Ward Backend Service class for easy access to all Ward APIs
export class WardBackendService {
  // Signals/Notifications
  static async getNotifications() {
    const wardResponse = await WardSignalService.getNotifications();
    return wardResponse;
  }

  static async getShopItem() {
    const response = await ShopService.getShopItems();
    return response;
  }

  // TODO: Add other services here as they are implemented
  // - Grades service
  // - Profile service
}
